import { render, staticRenderFns } from "./Bankslip.vue?vue&type=template&id=37de5b78&scoped=true&"
import script from "./Bankslip.vue?vue&type=script&lang=js&"
export * from "./Bankslip.vue?vue&type=script&lang=js&"
import style0 from "./Bankslip.vue?vue&type=style&index=0&id=37de5b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de5b78",
  null
  
)

export default component.exports